import { FC } from 'react';

import Callout from 'components/_core/Callout';
import { ApplicantType } from 'features/Onboarding/types';

import locales from './locales';

const OwnershipOtherCompanyMessage: FC<{
  onMoralBeneficiaryPress: () => void;
  applicantType: ApplicantType.AccountHolder | ApplicantType.Mandatee;
}> = ({ applicantType, onMoralBeneficiaryPress }) => (
  <Callout hideIcon>
    <Callout.Content>
      {locales.ownershipOtherCompanyLink[applicantType]}
    </Callout.Content>

    <Callout.Button onClick={onMoralBeneficiaryPress}>
      {locales.ownershipClickHere}
    </Callout.Button>
  </Callout>
);

export default OwnershipOtherCompanyMessage;
